<ng-container *transloco="let t">
  <editable-text
    appNavBreadcrumb
    [label]="strategyGroupName()"
    [tooltipText]="t('sp-strategy-group-page.change_strategy_group_name')"
    [disable]="!!isReadOnly()"
    (textChange)="updateStrategyName($event)"
  />
  <div class="flex h-full flex-col gap-4">
    @if (syncMessage()) {
      <IAlert [icon]="ICON_SYNC" [title]="syncMessage()!" />
    }
    <ITabs [tabs]="tabs()" [(activeTab)]="activeTab" />
    @if (strategyGroup()) {
      <div class="flex-1 px-2">
        @switch (selectedSection()) {
          @case (SECTIONS.PRODUCTS) {
            <strategy-group-products
              class="h-full"
              [strategyGroup]="strategyGroup()"
              [strategiesPerAsin]="strategiesPerAsin()"
              [isReadOnly]="!!isReadOnly()"
            />
          }
          @case (SECTIONS.CAMPAIGNS) {
            <strategy-group-strategies
              class="h-full"
              [strategyGroup]="strategyGroup()"
              [isReadOnly]="!!isReadOnly()"
              [accountMarketplace]="accountMarketplace()"
              [user]="user()"
            />
          }
          @case (SECTIONS.STATS) {
            <div class="ag-theme-quartz h-full">
              <app-advertising-stats-grid
                [fullHeight]="true"
                gridKey="strategyGroupStats"
                [hiddenColumns]="hiddenColumns"
                [dataFilter]="strategyGroupStatsFilter"
                [noStrategyLinks]="true"
              />
            </div>
          }
          @case (SECTIONS.ACTIVITIES) {
            <app-activity-component
              class="h-full"
              [activityFilter]="activityFilter()"
              gridConfigStorageKey="strategyGroupActivities"
            />
          }
          @case (SECTIONS.ADVANCED_SETTINGS) {
            <app-strategy-page-advanced-settings
              [advancedSettings]="advancedSettings"
              [strategyGroup]="strategyGroup()"
              [isReadOnly]="!!isReadOnly()"
            />
          }
        }
      </div>
    }
  </div>
</ng-container>
